import {useRouteLoaderData} from '@remix-run/react'

import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types/index.js'

function SectionHeadline({children}: {children: string}) {
  return <h3 className="mb-8 text-sm font-bold">{children}</h3>
}

export default function TermsOfService() {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  return (
    <div className="flex justify-center">
      <div className="content-container mx-auto mb-9 mt-10 px-4 text-[14px] tablet:mt-12 xs-mobile:mt-14">
        <h1 className="text-5xl mobile:text-3xl">{translations.TermsOfService.title}</h1>
        <h2 className="mt-4 text-xl">{translations.TermsOfService.subtitle}</h2>
        <hr className="mb-10 mt-10 h-1 w-full bg-gray-400" />
        <div className="text-sm">
          <ol className="">
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header1}</SectionHeadline>
              <p className="">{translations.TermsOfService.p1}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header2}</SectionHeadline>
              <ol>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p2_strong}</strong>
                  {translations.TermsOfService.p2}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p3_strong}</strong>
                  {translations.TermsOfService.p3}
                </li>
              </ol>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header3}</SectionHeadline>
              <ol>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p4_strong}</strong>
                  {translations.TermsOfService.p4}
                </li>

                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p5_strong}</strong>
                  {translations.TermsOfService.p5}
                </li>

                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p6_strong}</strong>
                  {translations.TermsOfService.p6}
                  <p className="mt-6">
                    <strong>{translations.TermsOfService.p7_strong}</strong>
                    {translations.TermsOfService.p7}
                  </p>
                </li>
              </ol>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header4}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p8}</p>
              <p className="mb-6">
                {translations.TermsOfService.p9}(<strong>{translations.TermsOfService.p9_strong}</strong>)
                {translations.TermsOfService.p10}
              </p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header5}</SectionHeadline>
              <ol>
                <li className="mb-6 list-inside">{translations.TermsOfService.list1_item1}</li>
                <li className="mb-6 list-inside">{translations.TermsOfService.list1_item2}</li>
                <li className="mb-6 list-inside">{translations.TermsOfService.list1_item3}</li>
              </ol>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header6}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p11}</p>
              <p className="mb-6">{translations.TermsOfService.p12}</p>
              <p className="mb-6">
                <strong>&ldquo;{translations.TermsOfService.p13_strong}&rdquo;</strong>
                {translations.TermsOfService.p13}
              </p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header7}</SectionHeadline>
              <p className="">{translations.TermsOfService.p14}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header8}</SectionHeadline>
              <p className="mt-8">
                {translations.TermsOfService.p15}
                <a aria-label="go to privacy policy page" href="/privacy-policy">
                  (&ldquo;{translations.TermsOfService.p16}&rdquo;)
                </a>
              </p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header9}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p17}</p>
              <p className="mb-6">{translations.TermsOfService.p18}</p>
              <p className="mb-6">{translations.TermsOfService.p19}</p>
              <p className="mb-6">{translations.TermsOfService.p20}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header10}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p21}</p>
              <p className="mb-6">{translations.TermsOfService.p22}</p>
              <p className="mb-6">{translations.TermsOfService.p23}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header11}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p24}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header12}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p25}</p>
              <p className="mb-6">{translations.TermsOfService.p26}</p>
              <p className="mb-6">
                {translations.TermsOfService.p27}
                {!!translations.TermsOfService.p28_strong.length && (
                  <strong> (&ldquo;{translations.TermsOfService.p28_strong}&rdquo;) </strong>
                )}
                {translations.TermsOfService.p28}
              </p>
              <p className="mb-6">{translations.TermsOfService.p29}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header13}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p30}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header14}</SectionHeadline>
              <p className="mb-6">{translations.TermsOfService.p31}</p>
              <p className="mb-6">{translations.TermsOfService.p32}</p>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header15}</SectionHeadline>
              <ol>
                <li className="mb-6 list-inside">
                  {!!translations.TermsOfService.p33_strong.length && (
                    <strong>{translations.TermsOfService.p33_strong}</strong>
                  )}
                  {translations.TermsOfService.p33}
                  {!!translations.TermsOfService.p34_strong.length && (
                    <strong>&ldquo;{translations.TermsOfService.p34_strong}&rdquo;</strong>
                  )}
                  {translations.TermsOfService.p34}
                  (&ldquo;
                  {!!translations.TermsOfService.p35_strong && (
                    <strong>{translations.TermsOfService.p35_strong}</strong>
                  )}
                  {translations.TermsOfService.p35}&rdquo;)
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p36_strong}</strong>
                  {translations.TermsOfService.p36}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p37_strong}</strong>.{translations.TermsOfService.p37}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p38_strong}</strong>.{translations.TermsOfService.p38}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p39_strong}</strong>.{translations.TermsOfService.p39}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p40_strong}</strong>.{translations.TermsOfService.p40}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p41_strong}</strong>.{translations.TermsOfService.p41}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p42_strong}</strong>.{translations.TermsOfService.p42}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p43_strong}</strong>.{translations.TermsOfService.p43}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p44_strong}</strong>.{translations.TermsOfService.p44}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p45_strong}</strong>.{translations.TermsOfService.p45}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p46_strong}</strong>.{translations.TermsOfService.p46}
                </li>
                <li className="mb-6 list-inside">
                  <strong>{translations.TermsOfService.p47_strong}</strong>.{translations.TermsOfService.p47}
                </li>
              </ol>
            </li>
            <li className="mb-8">
              <SectionHeadline>{translations.TermsOfService.header16}</SectionHeadline>
              <p className="mb-6">
                {translations.TermsOfService.p48}
                <a href="mailto:contact@roundforest.com" className="text-blue-600" aria-label="mail to contact">
                  contact@roundforest.com
                </a>
                .
              </p>
              <p className="mb-6">{translations.TermsOfService.p49}</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  )
}
